import toastr from 'toastr';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LegalEntityService } from '../../services/legal-entity.service';

@Component({
  selector: 'app-legal-entity-selector',
  templateUrl: './legal-entity-selector.component.html',
  styleUrls: ['./legal-entity-selector.component.css']
})
export class LegalEntitySelectorComponent implements OnInit {

  @Input() canChange: boolean;
  @Input() isAutonomoInitialValue: number | null;
  @Output() modify = new EventEmitter<number>();

  public formLegalEntityData: FormGroup;
  public isAutonomo: number;
  private legalEntitySub: Subscription; // Suscripción a los cambios en user.clientes.isAutonomo

  constructor(
    private formBuilder: FormBuilder,
    private legalEntityService: LegalEntityService,
  ) { }

  ngOnInit() {
    this.isAutonomo = this.isAutonomoInitialValue;

    this.formLegalEntityData = this.formBuilder.group({
      // El valor se convierte a string para que coincida con el `value` del <option>
      isAutonomo: [this.isAutonomoInitialValue !== null ? String(Number(this.isAutonomoInitialValue)) : null, [Validators.required]],
    });

    // Suscribirse a los cambios de la forma jurídica (cambios en user.clientes.isAutonomo)
    this.legalEntitySub = this.legalEntityService.isAutonomo$.subscribe(isAutonomo => {
      if (isAutonomo !== null) {
        this.isAutonomo = isAutonomo;
        // Se podría necesitar forzar la detección de cambios si el menú no se actualiza:
        // this.cdRef.detectChanges();
      }
    });
  }

  onModifyClick() {
    if (!this.canChange) {
      return;
    }

    if (this.formLegalEntityData.valid) {
      const value = +this.formLegalEntityData.value.isAutonomo;
      this.modify.emit(value);
    } else {
      toastr.error('Debe seleccionar una forma jurídica');
    }
  }
}
